import CentrosMedicos from "./CentrosMedicos";
export default CentrosMedicos;